import { AfterViewInit, Component, ComponentFactoryResolver, EventEmitter, Input, Output, ViewChild } from "@angular/core";
import { _MatTabGroupBase } from "@angular/material/tabs";
import { AppService } from "@api";
import { AlineacionImagenEnum } from "@componentes/Enums.enum";
import { RespuestaEstatusEnum } from "@enumeraciones/Enumeraciones.enum";
import { AlertaEnum } from "@mensaje/Enumeraciones/MensajeEnumeraciones.enum";
import { MensajeService } from "@mensaje/Mensaje.Service";
import { TranslateService } from "@ngx-translate/core";
import { SistemaService } from "@servicios/Sistema.Service";


@Component(
    {
        selector: 'reporteevaluacionpendientepreguntaenviadadetalle',
        templateUrl: './preguntaenviadadetalle.component.html',
    })

export class ReporteEvaluacionPendientePreguntaEnviadaDetalleComponent implements AfterViewInit{
    consulta!:boolean;
    public errorActivo!: boolean;
    @Input() entidad!: any;
    @Input() accion!: {accionid: number, accion: string};
    @Output() output = new EventEmitter();
    @ViewChild('tab') private tab!: _MatTabGroupBase;

    listaevaluador: any[] = [];
    listapreguntas:any[] = [];
    listacolaboradorrelacion: any[] = [];
    listatipoplantilla: any[] = [];

    ver:boolean = true;

    handleTabClick:any

    colaboradorrelacionid: number = 0;
    tipoplantillaid: number = 2;

    primeracarga: boolean = false;

    public AlineacionImagenEnum = AlineacionImagenEnum;

    validador: boolean = false;
    constructor(private appService: AppService, private mensajeService: MensajeService, public sistemaService: SistemaService, public translate: TranslateService, public _cfr: ComponentFactoryResolver){

    }

    ngAfterViewInit(){
              // 1. Save the click handler for later
              this.handleTabClick = this.tab._handleClick;
              // 2. Replace the click handler with our custom function
              this.tab._handleClick = (tab, header, index) => {
                  switch (this.tab.selectedIndex) {
                      case 0:
                      case 1:
                      case 2:
                      case 3:
                          this.handleTabClick.apply(this.tab, [tab, header, index]);
                          break;
                  }

              };
        this.verificar();
    }

    Salir(){
        this.output.next();
    }

    verificar(){
        this.appService.Post("reporte/preguntaenviada/evaluadoresbuscar",{"entidad":this.entidad, "tipobuscar":this.accion}).then(res=>{
            if(res.status == RespuestaEstatusEnum.Success){
                if(res.data == true){
                  if(this.accion.accionid == 1){
                    this.buscarevaluadores(this.colaboradorrelacionid);
                    this.colaboradorrelacion();
                    this.verpreguntas(this.colaboradorrelacionid);
                  }else if(this.accion.accionid == 5 || this.accion.accionid == 6){
                    this.verPreguntasTaller();
                    this.verAlumnoPadreTaller();
                  }
                  else{
                    this.buscarevaluadoresalumnos(this.tipoplantillaid);
                    this.tipodeevaluacion();
                    this.verpreguntasalumnos(this.tipoplantillaid);
                  }
                }else{
                    this.mensajeService.Alerta(AlertaEnum.Warning, "El periodo no tienen asignado el tipo de evaluacion: " + this.accion.accion);
                    this.output.next();
                }
            }
        })
    }

    buscarevaluadores(colaboradorrelacionid: any){
      if(colaboradorrelacionid !== ""){
        this.listaevaluador = [];
        this.appService.Post("reporte/preguntaenviada/buscarevaluaciones",{"entidad":this.entidad, "tipobuscar":this.accion, "colaboradorrelacionid": colaboradorrelacionid}).then(res=>{
          if(res.status == RespuestaEstatusEnum.Success){
              this.listaevaluador = res.data;
              this.verificadordato();
          }else{
              this.output.next();
          }
      })
      }else{
        this.listaevaluador = [];
      }
    }

    buscarevaluadoresalumnos(tipoplantillaid: any){
      if(tipoplantillaid != ""){
        this.listaevaluador = [];
        this.appService.Post("reporte/preguntaenviada/buscarevaluaciones",{"entidad":this.entidad, "tipobuscar":this.accion, "tipoplantillaid": tipoplantillaid}).then(res=>{
            if(res.status == RespuestaEstatusEnum.Success){
                this.listaevaluador = res.data;
                this.verificadordato();
            }else{
                this.output.next();
            }
        })
      }else{
        this.listaevaluador = [];
      }
  }

    colaboradorrelacion(){
      this.appService.Get("reporte/preguntaenviada/colaboradorrelacion").then(res =>{
        if(res.status == RespuestaEstatusEnum.Success){
          this.listacolaboradorrelacion = res.data;
        }
      })
    }

    verificadordato(){
      if(!this.primeracarga){
        if(this.listaevaluador.length == 0 && this.listapreguntas.length == 0){
          this.output.next();
        }else{
          this.primeracarga = true;
        }
      }else{
        this.primeracarga = true;
      }
    }

    verpreguntas(colaboradorrelacionid:any){
      if(colaboradorrelacionid !== ""){
        this.listapreguntas = [];
        this.buscarevaluadores(colaboradorrelacionid);
        this.appService.Post("reporte/preguntaenviada/buscarpreguntas",{"entidad":this.entidad, "tipobuscar":this.accion, "colaboradorrelacionid": colaboradorrelacionid}).then(res =>{
          if(res.status == RespuestaEstatusEnum.Success){
            this.listapreguntas = res.data;
            this.verificadordato();
          }
        })
      }else{
        this.listapreguntas = [];
        this.buscarevaluadores(colaboradorrelacionid);
      }
    }

    verpreguntasalumnos(tipoplantillaid:any){
      if(tipoplantillaid != ""){
        this.listapreguntas = [];
        this.buscarevaluadoresalumnos(tipoplantillaid);
        this.appService.Post("reporte/preguntaenviada/buscarpreguntas",{"entidad":this.entidad, "tipobuscar":this.accion, "tipoplantillaid": tipoplantillaid}).then(res =>{
          if(res.status == RespuestaEstatusEnum.Success){
            this.listapreguntas = res.data;
            this.verificadordato();
          }
        })
      }else{
        this.listapreguntas = [];
        this.buscarevaluadoresalumnos(tipoplantillaid);
      }
    }

    verPreguntasTaller(){
      this.listapreguntas = [];
      this.appService.Post("reporte/preguntaenviada/buscarpreguntastaller",{"entidad":this.entidad, "tipobuscar":this.accion}).then(res =>{
        if(res.status == RespuestaEstatusEnum.Success){
          this.listapreguntas = res.data;
          this.verificadordato();
        }
      })
    }

    verAlumnoPadreTaller(){
      this.listaevaluador = [];
      this.appService.Post("reporte/preguntaenviada/buscarevaluacionestaller",{"entidad":this.entidad, "tipobuscar":this.accion}).then(res=>{
          if(res.status == RespuestaEstatusEnum.Success){
              this.listaevaluador = res.data;
              this.verificadordato();
          }else{
              this.output.next();
          }
      })
    }

    tipodeevaluacion(){
      this.appService.Get("reporte/preguntaenviada/tipoplantilla").then(res=>{
        if(res.status == RespuestaEstatusEnum.Success){
          this.listatipoplantilla = res.data;
        }
      })
    }

    Exportar(){
        this.appService.PostGetFile("reporte/preguntaenviada/layoutreporte",{"pregunta":this.listapreguntas, "evalua":this.listaevaluador, "entidad":this.entidad, "tipobuscar":this.accion}).then(res=>{
            if(res.status == RespuestaEstatusEnum.Success){

            }
        })
    }

    formulario(){

    }
}
